<template lang="pug">
  transition(name="fade")
    .search(v-show="isInit" :class="getClass()")
          .tab-btn
            ul
              li.btn.concour(@click="onClickTab(0)" :class="{show: currentTab === 0}")
                span.alp コンクール
              li.btn.teaching(@click="onClickTab(1)" :class="{show: currentTab === 1}")
                span.alp 教材
              li.btn.event(@click="onClickTab(2)" :class="{show: currentTab === 2}")
                span.alp イベント
          .tab-contents.concour(:style="getTabStyle(0)" v-visible="currentTab === 0")
            .select-area
              div
                label 学年から探す
                .select-box
                  select.sort1(v-model="concourSelected['0']")
                    option(value="0") すべて
                    option(v-for="c0 in commonConcour[0]" :value="c0.term_id")
                      | {{ c0.name }}
                  span
              div
                label カテゴリから探す
                .select-box
                  select.sort2(v-model="concourSelected['1']")
                    option(value="0") すべて
                    option(v-for="c1 in commonConcour[1]" :value="c1.term_id")
                      | {{ c1.name }}
                  span
              .search-btn
                input.alp(type="submit" value="検索" @click.prevent.stop="onClickSubmit(0)")
            .card-area
              template(v-if="data[0] && data[0].posts && data[0].posts.length")
                Card(type="concour" :key="dt.ID" :data="dt", v-for="(dt, i) in data[0].posts", :currentTab.sync=currentTab, :tab="0", :commonData="getCommonData('concour')")
                Card(v-if="data[0].posts.length === 2" :isDummy="true")
              div.none(v-else-if="!data[currentTab].isBusy")
                div
                  | 該当するものがございませんでした。
                  br
                  | 他のキーワードで再度お試しください。
            .to-list-btn
              a.alp(href="/concour/")
                span コンクール情報一覧ページを見る
          .tab-contents.teaching(:style="getTabStyle(1)" v-visible="currentTab === 1")
            .select-area
              div
                label 学年から探す
                .select-box
                  select.sort1(v-model="teachingSelected['0']")
                    option(value="0") すべて
                    option(v-for="t0 in commonTeaching[0]" :value="t0.term_id")
                      | {{ t0.name }}
                  span
              div
                label カテゴリから探す
                .select-box
                  select.sort2(v-model="teachingSelected['1']")
                    option(value="0") すべて
                    option(v-for="t1 in commonTeaching[1]" :value="t1.term_id")
                      | {{ t1.name }}
                  span
              .search-btn
                input.alp(type="submit" value="検索" @click.prevent.stop="onClickSubmit(1)")
            .card-area
              template(v-if="data[1] && data[1].posts && data[1].posts.length")
                Card(type="teaching" :key="dt.ID" :data="dt", v-for="(dt, i) in data[1].posts", :currentTab.sync=currentTab, :tab="1", :commonData="getCommonData('teaching')")
                Card(v-if="data[1].posts.length === 2" :isDummy="true")
              div.none(v-else-if="!data[currentTab].isBusy")
                div
                  | 該当するものがございませんでした。
                  br
                  | 他のキーワードで再度お試しください。
            .to-list-btn
              a.alp(href="/teaching/")
                span 教材情報一覧ページを見る
          .tab-contents.event(:style="getTabStyle(2)" v-visible="currentTab === 2")
            .select-area
              div
                label 開催月から探す
                .select-box
                  select.sort1(v-model="eventSelected['1']")
                    option(value="0") すべて
                    option(v-for="e0 in commonEvent[1]" :value="e0.term_id")
                      | {{ e0.name }}
                  span
              div
                label エリアから探す
                .select-box
                  select.sort2(v-model="eventSelected['0']")
                    option(value="0") すべて
                    option(v-for="e1 in commonEvent[0]" :value="e1.term_id")
                      | {{ e1.name }}
                  span
              .search-btn
                input.alp(type="submit" value="検索" @click.prevent.stop="onClickSubmit(2)")
            .card-area
              template(v-if="data[2] && data[2].posts && data[2].posts.length")
                Card(type="event" :key="dt.ID" :data="dt", v-for="(dt, i) in data[2].posts", :currentTab.sync=currentTab, :tab="2", :commonData="getCommonData('event')")
                Card(v-if="data[2].posts.length === 2" :isDummy="true")
              div.none(v-else-if="!data[currentTab].isBusy")
                div
                  | 該当するものがございませんでした。
                  br
                  | 他のキーワードで再度お試しください。
            .to-list-btn
              a.alp(href="/event/")
                span イベント情報一覧ページを見る
</template>

<style lang="scss" scoped>
.busy {
  transition: 0.1s opacity ease-in;
  .card-area,
  .select-area {
    transition: 0.1s opacity ease-in;
    opacity: 0.5;
  }
}
@mixin flex($jc: space-between) {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: $jc;
}
$concour: #00a8ff;
$teaching: #f99709;
$event: #2eb024;
.search {
  // .tab-btn
  .tab-btn {
    margin: 50px 0 25px;
    ul {
      @include flex();
      align-items: flex-end;
    }
    .btn {
      width: 31.43%;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      text-align: center;
      line-height: 2.6;
      border-radius: 3px;
      cursor: pointer;
      background: #fff;
      overflow: hidden;
      span {
        width: 100%;
        display: block;
      }
    }
    .concour span {
      background: $concour;
    }
    .teaching span {
      background: $teaching;
    }
    .event span {
      background: $event;
    }
    .concour.show {
      background: url(../../assets/img/common/top_tab01_pc.png) no-repeat;
    }
    .teaching.show {
      background: url(../../assets/img/common/top_tab02_pc.png) no-repeat;
    }
    .event.show {
      background: url(../../assets/img/common/top_tab03_pc.png) no-repeat;
    }
    .btn.show {
      margin-bottom: -10px;
      line-height: 3.8;
      padding-bottom: 10px;
      background-size: 100% auto;
      cursor: default;
      span {
        opacity: 1 !important;
        background: none;
      }
    }
  }
  // .tab-contents
  .tab-contents {
    .to-list-btn {
      width: 48.98%;
      margin: 40px auto 0;
      background: #fff;
      span {
        padding-left: 24px;
        &:before {
          content: " ";
          border: 8px dashed transparent;
          left: 0;
        }
      }
    }
    .card-area {
      min-height: 315px;
      .none {
        background-color: #ffffff;
        font-size: 18px;
        line-height: 1.7;
        text-align: center;
        width: 100%;
        padding-top: 100px;
        padding-bottom: 100px;
        padding-left: 5%;
        padding-right: 5%;
        color: #333333;
        position: relative;
        > div {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
      }
      @media only screen and (max-width: 750px) {
        .none {
          font-size: 14px;
        }
      }
    }
    &.concour {
      .select-area {
        margin-bottom: 38px;
        label {
          color: $concour;
        }
        span {
          background: $concour;
        }
        input {
          background-color: $concour;
        }
      }
      .to-list-btn a {
        color: $concour;
        border: 3px solid $concour;
        span:before {
          border-left: 12px solid $concour;
        }
      }
    }
    &.teaching {
      .select-area {
        margin-bottom: 38px;
        label {
          color: $teaching;
        }
        span {
          background: $teaching;
        }
        input {
          background-color: $teaching;
        }
      }
      .to-list-btn a {
        color: $teaching;
        border: 3px solid $teaching;
        span:before {
          border-left: 12px solid $teaching;
        }
      }
    }
    &.event {
      .select-area {
        margin-bottom: 38px;
        label {
          color: $event;
        }
        span {
          background: $event;
        }
        input {
          background-color: $event;
        }
      }
      .to-list-btn a {
        color: $event;
        border: 3px solid $event;
        span:before {
          border-left: 12px solid $event;
        }
      }
    }
  }
  .select-area {
    .search-btn {
      width: 102px;
    }
  }

  @media only screen and (max-width: 1000px) {
    .tab-btn .btn.show {
      line-height: 5.3vw;
    }
  }
  @media only screen and (max-width: 750px) {
    .tab-btn {
      margin: 11vw 0 8vw;
      .btn {
        font-size: 1.28rem;
        line-height: 2.2;
      }
      .concour.show {
        background: url(../../assets/img/common/top_tab01_sp.png) no-repeat;
      }
      .teaching.show {
        background: url(../../assets/img/common/top_tab02_sp.png) no-repeat;
      }
      .event.show {
        background: url(../../assets/img/common/top_tab03_sp.png) no-repeat;
      }
      .btn.show {
        width: 32.6%;
        background-size: 100% auto;
        line-height: 2.6;
        padding: 0.1em 0 0.5em;
        margin-bottom: -0.5em;
      }
    }
    .tab-contents {
      .select-area {
        .search-btn {
          width: 100%;
          margin-top: 6%;
        }
      }
      .to-list-btn {
        border: 1.5px solid $concour;
        margin: 8vw auto 9.5vw;
        span {
          padding-left: 4.8vw;
          &:before {
            border: 1.6vw dashed transparent !important;
          }
        }
      }
      &.concour {
        .to-list-btn {
          border: 1.5px solid $concour;
          span:before {
            border-left: 2.4vw solid $concour !important;
          }
        }
      }
      &.teaching {
        .to-list-btn {
          border: 1.5px solid $teaching;
          span:before {
            border-left: 2.4vw solid $teaching !important;
          }
        }
      }
      &.event {
        .to-list-btn {
          border: 1.5px solid $event;
          span:before {
            border-left: 2.4vw solid $event !important;
          }
        }
      }
    }
  }
}
</style>

<script>
import $ from "jquery";
import _ from "lodash";
import Card from "../../components/common/Card";
export default {
  data: () => {
    return {
      currentTab: 0,
      isInit: false,
      concourSelected: { "0": 0, "1": 0 },
      teachingSelected: { "0": 0, "1": 0 },
      eventSelected: { "0": 0, "1": 0 },
      isBusy: false
    };
  },
  computed: {
    data() {
      return _.clone([
        this.$store.state.data.concourSearch,
        this.$store.state.data.teachingSearch,
        this.$store.state.data.eventSearch
      ]);
    },
    commonData() {
      return this.$store.state.data.searchCommon || {};
    },
    commonConcour() {
      return [
        this.commonData["concour_age"],
        this.commonData["concour_category"]
      ];
    },
    commonTeaching() {
      return [
        this.commonData["teaching_age"],
        this.commonData["teaching_category"]
      ];
    },
    commonEvent() {
      return [this.commonData["event_area"], this.commonData["event_date"]];
    }
  },
  methods: {
    getTabStyle(index) {
      return this.currentTab !== index
        ? {
            height: "0",
            overflow: "hidden",
            position: "relative",
            zIndex: "-9999"
          }
        : {};
    },
    getCommonData(type) {
      switch (type) {
        case "concour":
          return this.commonConcour;
        case "teaching":
          return this.commonTeaching;
        case "event":
          return this.commonEvent;
      }
    },
    onClickTab(i) {
      this.currentTab = i;
    },
    onClickSubmit(i) {
      this.isBusy = true;
      this.fetchData(i);
    },
    fetchData(tabIndex) {
      // (?P<post_type>\S+)/(?P<category_id>\d+)/(?P<tag_id>\d+)/(?P<page>\d+)
      let type;
      let selected;
      switch (tabIndex) {
        case 0:
          type = "concour";
          selected = this.concourSelected;
          break;
        case 1:
          type = "teaching";
          selected = this.teachingSelected;
          break;
        case 2:
          type = "event";
          selected = this.eventSelected;
          break;
      }
      this.$store.dispatch("fetchData", {
        url: "wp-json/custom/search",
        key: type + "Search",
        name: `${type}/${selected[1]}/${selected[0]}/0`
      });
    },
    getClass() {
      const obj = {};
      obj.busy = this.data[this.currentTab].isBusy === true;
      return obj;
    }
  },
  components: {
    Card
  },
  created() {
    this.$store.dispatch("fetchData", {
      url: "wp-json/custom/search-common",
      key: "searchCommon"
    });
    this.fetchData(0);
    this.fetchData(1);
    this.fetchData(2);
  },
  watch: {
    data(dt) {
      if (!this.isInit && dt[0] && dt[0].posts) {
        this.isInit = true;
      }
      this.isBusy = false;
    },
    currentTab() {
      setTimeout(() => {
        $(window).resize();
      }, 1);
    }
  }
};
</script>